import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { } from 'googlemaps';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-google-location-finder',
  templateUrl: './google-location-finder.component.html',
  styleUrls: ['./google-location-finder.component.css']
})
export class GoogleLocationFinderComponent implements OnInit, AfterViewInit {

  @Input() addressType: string = 'geocode';
  @Input() address: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('address') addresstext: any; // Needs to be any due to different address formats

  addressFormControl = new FormControl('', [
    Validators.required
  ]);

  matcher = new MyErrorStateMatcher();

  constructor() { }

  ngOnInit(): void {
    console.log("ngOnit address1");
    console.log(this.address);
    if (this.address !== "address") {
      console.log("ngOnit address2");
      this.addressFormControl.setValue(this.address);
    }
  }

  ngAfterViewInit() {
    // if (this.address !== "") {
    //   this.addresstext = this.address;
    //   this.addresstext.nativeElement.innerText = this.address;
    //   console.log(this.addresstext.nativeElement.textContent);
    // }
    this.getLocation();
  }

  private getLocation() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
    {
        componentRestrictions: { country: 'UK' },
        types: [this.addressType]  // 'establishment' / 'address' / 'geocode'
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

}
